// extracted by mini-css-extract-plugin
export default {"link":"AddServiceLink-module_link_c7bea2"};